/**
 * @description Gestion des tailles de textes coupés
 */

(() => {
  setTimeout(() => {
    activeDot();
  }, 200);
})();
